// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"646":"698ce0eb","3417":"d3f083ac"}[chunkId] + ".chunk.css";
};